import { motion } from "framer-motion";

const COLORS = ["#FF5A4E", "#FFC72C", "#3B82F6", "#19B37A", "#8B5CF6"];
const PIECES = Array.from({ length: 36 }, (_, i) => ({
  x: (Math.random() - 0.5) * 520,
  y: -Math.random() * 260 - 40,
  r: Math.random() * 540,
  c: COLORS[i % COLORS.length],
  d: Math.random() * 0.2,
}));

export const Confetti = () => (
  <div className="pointer-events-none absolute left-1/2 top-1/2">
    {PIECES.map((p, i) => (
      <motion.span
        key={i}
        className="absolute w-2.5 h-4 rounded-sm"
        style={{ background: p.c }}
        initial={{ x: 0, y: 0, opacity: 1, rotate: 0 }}
        animate={{ x: p.x, y: [0, p.y, p.y + 320], opacity: [1, 1, 0], rotate: p.r }}
        transition={{ duration: 1.8, delay: p.d, ease: "easeOut" }}
      />
    ))}
  </div>
);
